import React, { useState } from "react";
import { isEmail } from "validator";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../../firebase';
import { showSuccessAlert, showErrorAlert, showWarningAlert, showInfoAlert, showConfirmDialog } from '../../utils/sweetAlertConfig';
import '../../styles/sweetAlert.css';
import "./loginStyle.css";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");


  const handleInputChange = (e) => {
    setEmail(e.target.value);
    setError("");
    setMessage("");
  };

  const handleSendResetEmail = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!isEmail(email)) {
      setError("Please enter a valid email");
      return;
    }
    setIsSending(true);
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setMessage("A password reset link has been sent to your email. Please check your inbox (and spam folder).");

      // show success and erro message using sweetalert2 (changl diste he )

    } catch (err) {
      setError(err.message || "Failed to send reset email. Please try again.");

    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="col-md-12 login-container">
      <div className="card card-container light-theme">
        <h3 className="login-title">Reset Password</h3>
        <form onSubmit={handleSendResetEmail} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              className={`form-control light-input ${error ? 'is-invalid' : ''}`}
              name="email"
              value={email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              disabled={isSending}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
          <div className="form-group">
            <button
              type="submit"
              className="btn gradient-btn"
              disabled={isSending}
            >
              {isSending ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Sending...
                </>
              ) : (
                "Send Reset Link"
              )}
            </button>
          </div>
          {message && (
            <div className="alert alert-success" role="alert">
              {message}
            </div>
          )}
          <div className="form-group mt-3">
            <button
              type="button"
              className="btn btn-link"
              onClick={onBack}
              disabled={isSending}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword; 